module.exports = __webpack_public_path__ + "img/bg_graduacao-presencial.7a28d414.jpg";